<template>
<div class="testApp">
  <img src="./assets/colabear.jpeg" style="width: 150px;">
  <h1>재밌는 테스트 모음</h1>
  <p>"안녕하세요 콜라베어 입니다. 요즘 어쩌구 저쩌구 테스트들이 많더라구요 심심해서
    공부할겸 여러 테스트를 만들어 봤습니다. 대부분의 테스트는 적절한 알고리즘으로 제작되어
    나름의 정확성을 보입니다만 재미로 봐주는게 좋으실겁니다."</p>
    <p>ps.생각 날때마다 재밌는 테스트 추가 예정입니다.</p>
  <hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">
<MainCompoent></MainCompoent>
<hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">
<TestComponent></TestComponent>
</div>
</template>

<script>
import MainCompoent from './components/MainComponent.vue'
import TestComponent from './components/TestComponent.vue'

export default {
  name: 'App',
  components: {
    MainCompoent,
    TestComponent,

  },
  data(){
    return{

    }
  },

}
</script>

<style>
body {
  margin: 10px;
}
#app {
  box-sizing: border-box;
  font-family: "consolas";
  margin-top: 60px;
  width: 100%;
  max-width: 460px;
  margin: auto;
  position: relative;
  border: 5px solid #eee;
  border-radius: 20px;
  /* height: 1000px; */
  
}
.testApp{
  text-align: center;
  /* height: 1000px; */
  margin-top: 50px;
  margin-right:20px;
  margin-left:20px;
  margin-bottom: 70px;

}

</style>
